import { FC } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Input } from "../components/Form/Input";
import { Button } from "../components/Form/Button";
import { FormErrorsSchema } from "../types";

type InputMask = (inputText: string) => string;

interface TwoStepChangePageProps {
  title: string;
  breadcrumbLabel?: string;
  currentLabel: string;
  currentValue: string;
  newLabel: string;
  newFieldName: string;
  newValue: string;
  setNewValue: (value: string) => void;
  newInputMask?: InputMask;
  confirmLabel: string;
  confirmFieldName: string;
  tokenValue: string;
  setTokenValue: (value: string) => void;
  requested: boolean;
  loading: boolean;
  loadingIdentity?: boolean;
  formErrors: FormErrorsSchema;
  onRequest: () => void;
  onConfirm: () => void;
  requestButtonLabel: string;
  confirmButtonLabel: string;
  tokenInputMask?: InputMask;
}

/**
 * Shared layout and controls for two-step profile changes (request + confirm).
 */
const TwoStepChangePage: FC<TwoStepChangePageProps> = ({
  title,
  breadcrumbLabel = title,
  currentLabel,
  currentValue,
  newLabel,
  newFieldName,
  newValue,
  setNewValue,
  newInputMask,
  confirmLabel,
  confirmFieldName,
  tokenValue,
  setTokenValue,
  requested,
  loading,
  loadingIdentity = false,
  formErrors,
  onRequest,
  onConfirm,
  requestButtonLabel,
  confirmButtonLabel,
  tokenInputMask = (inputText: string) => inputText.replaceAll(/[^a-zA-Z0-9]/g, ""),
}) => {
  return (
    <div className="w-full lg:w-2/3 min-h-screen bg-gray-100 text-gray-900">
      <main className="mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <Breadcrumb
          pages={[
            { name: "My account", href: "#", current: false },
            { name: breadcrumbLabel, href: "#", current: true },
          ]}
        />
        <div className="mt-8">
          <h1 className="text-xl font-semibold">{title}</h1>
        </div>
        <div className="bg-white mt-6 px-6 pb-6 pt-2">
          <div className="w-full">
            <div className="w-full mt-6">
              <Input
                label={currentLabel}
                name="currentValue"
                value={currentValue}
                required={true}
                disabled={true}
              />
            </div>
            <div className="w-full mt-6">
              <Input
                label={newLabel}
                name={newFieldName}
                placeholder=""
                errors={formErrors}
                value={newValue}
                setValue={setNewValue}
                disabled={loading || loadingIdentity}
                required={true}
                inputMask={newInputMask}
              />
            </div>
            {requested && (
              <div className="w-full mt-6">
                <Input
                  label={confirmLabel}
                  name={confirmFieldName}
                  placeholder=""
                  errors={formErrors}
                  value={tokenValue}
                  setValue={setTokenValue}
                  disabled={loading}
                  required={true}
                  inputMask={tokenInputMask}
                />
              </div>
            )}
          </div>
          <div className="w-full mt-10">
            {!requested && (
              <Button
                label={requestButtonLabel}
                disabled={loading}
                theme="primary"
                size="medium"
                className="block w-full md:ml-auto md:w-auto"
                onClick={onRequest}
              />
            )}

            {requested && (
              <Button
                label={confirmButtonLabel}
                disabled={loading}
                theme="primary"
                size="medium"
                className="block w-full md:ml-auto md:w-auto"
                onClick={onConfirm}
              />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default TwoStepChangePage;

